import { AT_USER }  from "./actions-types";
import axios        from "../../../services/axios/CustomAxios";
import { apiUrl }   from "app/services/axios/configApi";
import _            from '@lodash';
import * as Actions from 'app/store/actions';

export function updateUserData(next = () => {}) {
    return dispatch => {
        axios.get(apiUrl + "/auth/currentInfo").then(response => {
            const data = response.data.data;

            dispatch(setUserData(
                Boolean(data.permissions) ? data : { ...data, permissions: [{ code: "contractor_panel" }] })
            );

            next();
        }).catch(() => dispatch(
            Actions.showMessage(
                {
                    message         : "Code invalide",
                    autoHideDuration: 5000,
                    anchorOrigin    : {
                        vertical  : "top",
                        horizontal: "center",
                    },
                    variant         : "error",
                }
            )
        ));
    };
}

export function setUserData(user) {
    return function (dispatch) {
        dispatch({
                     type   : AT_USER.USER_UPDATE_CURRENT,
                     payload: user,
                 });

    };
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
    return (dispatch, getState) => {
        const oldUser = getState().auth.user;
        const user = _.merge({}, oldUser, { data: { settings } });

        updateUserData(user);

        return dispatch(setUserData(user));
    }
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
    return (dispatch, getState) => {
        const user = getState().auth.user;
        const newUser = {
            ...user,
            data: {
                ...user.data,
                shortcuts
            }
        };

        updateUserData(newUser);

        return dispatch(setUserData(newUser));
    }
}
